"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackBenefitBanner = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _Buttons = require("../Buttons");
var _CopyLinkAndWelcomeMessage = require("../CopyLinkAndWelcomeMessage");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Shows feedback benefit banner that can be displayed in Dialog
 */
const FeedbackBenefitBanner = ({
  data: {
    message,
    readMoreLink,
    registerLink,
    signInLink,
    title,
    welcomeMessage
  },
  link
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.FEEDBACK_BENEFIT_BANNER),
    children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      "data-testid": getTestId(_constants.TITLE),
      variant: "h4",
      component: "h4",
      children: title
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [message ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        "data-testid": getTestId(_constants.MESSAGE),
        children: message
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_CopyLinkAndWelcomeMessage.CopyLinkAndWelcomeMessage, {
        link: link,
        welcomeMessage: welcomeMessage
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Buttons.Buttons, {
        registerLink: registerLink,
        signInLink: signInLink
      })]
    }), readMoreLink?.relativeUrl && readMoreLink.title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
      component: "a",
      "data-testid": getTestId(_constants.READ_MORE),
      variant: "button",
      color: "textPrimary",
      href: readMoreLink.relativeUrl,
      children: readMoreLink.title
    }) : null]
  });
};
exports.FeedbackBenefitBanner = FeedbackBenefitBanner;
